<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :modal="false"
    :title="$t('SeaExport.FileUpload')"
    width="670px"
    :close-on-click-modal="false"
    :class="'app-main-inner'+(uploading?' not-click':'')"
    :append-to-body="true"
  >
    <div class="app-main-inner-row row-grid" style="display:flex;min-height:350px;padding:0">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%"
        class="upload-table"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-upload
        action
        multiple
        :auto-upload="false"
        :show-file-list="false"
        :on-change="toChooseFile"
        style="float:left;margin-left:30px;margin-right:5px"
        no="1"
      >
        <el-button type="primary">{{ $t('SeaExport.SelectFile') }}</el-button>
      </el-upload>
      <el-button type="primary" style="float:left" no="2" @click="batchSetCategory">{{ $t('CargoMsg.Cargo_BatchSetCategory') }}</el-button>
      <el-button type="danger" style="float:left" no="3" @click="remove()">{{ $t('SeaExport.DeleteFile') }}</el-button>
      <el-button type="primary" no="4" @click="upload()">{{ $t('SeaExport.Upload') }}</el-button>
      <el-button no="5" @click="innerVisible=false">{{ $t('SeaExport.Close') }}</el-button>
    </span>
    <!-- 文档类别弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="docTypeTree.visible"
      :title="$t('SeaExport.Edit')"
      width="400px"
      :close-on-click-modal="false"
      class="app-main-inner"
      append-to-body
    >
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="docTypeTree.gridOptions"
          :row-data="docTypeTree.rowData"
          style="width:350px;height:300px;padding-left:2px"
          @gridReady="params=>docTypeTree.gridApi=params.api"
        />
      </div>
      <span slot="footer" style="padding-right:30px">
        <el-button type="primary" no="6" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="7" @click="docTypeTree.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { Company } from '@/class/model/mdm/Company'
import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { Quotation } from '@/class/model/price/Quotation'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { getFileList, uploadStorage, deleteFile, uploadBillPaymentStorage, batchUploadStorage } from '@/api/storage'
import { getLoading } from '@/utils/utilBaseElement'
import { deleteFileToWeaver } from '@/api/clearing/billPayment.js'
import URL from '@/api/urlTranslator'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'CargoCloudFileUpload',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    lob: { type: String, default: '' },
    showAll: { type: Boolean, default: false },
    isSirui: { type: Boolean, default: false }, // 是否思锐定制化上传，false走公共
    batchUploadData: { type: Object, required: false, default: null }, // 批量上传文件定制化上传，false走公共
    uploadSource: { type: String, required: false, default: '' },
    otherUploadFunc: { type: Function, required: false, default: null }, // 其他上传事件
    otherParam: { type: Object, required: false }, // 其他参数
    fileSize: { type: Number, required: false }, // 文件大小
    shouldEncodeUuid: { type: Boolean, default: false } // 是否对uuid进行、url编码
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      otherProcessing: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.FileName'),
          colId: 'fileName',
          field: 'fileName',
          width: 175,
          cellRenderer: params => {
            if (params.data.fileId) {
              return `<a href="${URL.common.findByFileId}/${
                params.data.fileId
              }?sessionId=${
                this.user.sessionId
              }" target="_blank" style="color:blue">${params.value}</a>`
            } else {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('SeaExport.FileType'),
          colId: 'fileType',
          field: 'fileType',
          width: 115
        },
        {
          headerName: this.$t('SeaExport.FileSize'),
          colId: 'fileSize',
          field: 'fileSize',
          width: 115,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(2) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('SeaExport.UploadProgress'),
          colId: 'uploadProgress',
          field: 'uploadProgress',
          width: 115,
          cellRenderer: params => {
            if (params.data && params.data.uploadProgress) {
              return params.data.uploadProgress
            } else if (params.data && params.data.duplicate && params.data.duplicate === 1) {
              return this.$t('CargoMsg.Cargo_UploadedRepeatedly')
            } else {
              if (params.value) {
                return `<span style="color:green">${this.$t('Message.Uploaded')}</span>`
              }
              if (this.uploading) {
                return this.$t('queryJob.uploading') + '...'
              }
              return this.$t('Message.Waiting')
            }
          },
          tooltipValueGetter: (params) => {
            if (params.data && params.value) {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('SeaExport.DocumentType'),
          colId: 'fileCategoryLabel',
          field: 'fileCategoryLabel',
          width: 115,
          cellRenderer: params => {
            if (params.data.fileId) {
              return params.value
            } else {
              const methodPath = this.documentManage.getPath('showDocTypeTree')
              return `<div onclick="${methodPath}(${
                params.data.seq
              })" style="cursor:pointer">${params.value || '&nbsp;'}</div>`
            }
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeTree: {
        visible: false,
        isBatchSave: false, // 是否批量保存
        gridOptions: {
          // 自行实现多选
          // rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  let borderColor = '#999999'
                  let iconColor = 'transparent'
                  if (params.data.checked) {
                    borderColor = '#1F75D5'
                    iconColor = '#1F75D5'
                  }
                  return `<i class="el-icon-check" style="height:1.3em;width:1.3em;border:1.5px solid ${borderColor};border-radius:0.65em;line-height:1.3em;vertical-align:text-bottom;background:white;color:${iconColor};font-size:12px;"></i>
                          &nbsp;${this.isZh ? params.data.chineseName : params.data.englishName}`
                }
                return this.isZh ? params.data.chineseName : params.data.englishName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                // 重置所有选中
                // if (checked) {
                //   this.docTypeTree.rowData.forEach(item => {
                //     item.checked = false
                //   })
                // }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      docTypeMap: new Map(),
      uploading: false,
      loading: null,
      selectedNode: null,
      batchUploading: false // 批量上传校验上传中
    }
  },
  computed: {
    finalLob() {
      return this.lob || this.job.lob
    },
    selectedFile() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.$emit('uploadDone', this.rowData)
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    },
    finalLob(newVal) {
      this.buildDocTypeTree()
    }
  },
  async created() {
    await this.buildDocTypeTree()
    if (this.visible) {
      this.innerVisible = true
      await this.initData()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      context.showDocTypeTree(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      if (this.showAll) {
        await this.toQuery()
      }
    },
    toQuery() {
      const xmlParam =
        '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
        this.job.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      return getFileList(xmlParam).then(res => {
        this.rowData = Array.from(res.data, p => {
          const fileName = p.fileName
          const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
          const fileCategory = p.extendMetaData.documentType || ''
          const fileCategoryLabel = this.docTypeMap.get(
            fileCategory.toUpperCase()
          )
          return {
            seq: this.autoIncrementNum.getNextNum(),
            fileId: p.id,
            fileName,
            fileType,
            fileSize: p.fileSize,
            fileCategory,
            fileCategoryLabel,
            params: {}
          }
        })
      })
    },
    async buildDocTypeTree() {
      if (this.finalLob) {
        getDocCategoryTypeTreeByLob({
          constructLobParent: false,
          lob: this.finalLob
        }).then(res => {
          const data = res.data.filter(p => {
            const pathArr = p.path.split(',')
            if (p.type === 1) {
              return pathArr.length === 1
            }
            if (p.type === 2) {
              return pathArr.length > 1
            }
            return false
          })
          data.forEach(item => {
            item.checked = false
            if (item.type === 2) {
              this.docTypeMap.set(item.code.toUpperCase(), this.isZh ? item.chineseName : item.englishName)
            }
          })
          this.docTypeTree.rowData = data
        })
      } else {
        this.docTypeTree.rowData = []
      }
    },
    toChooseFile(file) {
      if (this.fileSize && this.fileSize > 1) {
        if (file.size > this.fileSize) {
          this.$message.warning(this.$t('Message.N1Exceeds4MBCannotUploaded'))
          return
        }
      } else {
        if (file.size > 20 * 1024 * 1024) {
          this.$message.warning(this.$t('Message.N1Exceeds20MBCannotUploaded'))
          return
        }
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const params = { file: file.raw }
      if (this.job instanceof Job) {
        params.jobNo = this.job.jobNo
        params.mbl = this.job.mbl
      } else if (
        this.job instanceof Company ||
        this.job instanceof QuotationClient
      ) {
        params.companyKey = this.job.uuid
      } else if (this.job instanceof Quotation) {
        params.quotationUuid = this.job.uuid
      }
      params.uuid = this.shouldEncodeUuid ? encodeURIComponent(this.job.uuid) : this.job.uuid
      if (this.job.hasOwnProperty('documentType')) {
        params.documentType = this.job.documentType
      }
      params.createdBy = this.user.userId
      params.createChineseName = this.user.chineseName
      params.createEnglishName = this.user.englishName
      this.rowData.push({
        seq: this.autoIncrementNum.getNextNum(),
        fileId: '',
        fileName,
        fileType,
        fileSize: file.size,
        fileCategory: '',
        fileCategoryLabel: '',
        params
      })
    },
    showDocTypeTree(seq) {
      const rows = this.rowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      const fileCategories = fileCategory ? fileCategory.split(',') : []
      this.docTypeTree.rowData.forEach(item => {
        if (fileCategories.length > 0 && fileCategories.includes(item.code.toUpperCase())) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      this.docTypeTree.rowData = [...this.docTypeTree.rowData]
      this.docTypeTree.isBatchSave = false
      this.docTypeTree.visible = true
    },
    saveDocType() {
      const docTypeRows = this.docTypeTree.rowData.filter(
        p => p.type === 2 && p.checked
      )
      let fileCategory = ''
      let fileCategoryLabel = ''
      let documentTypeUuid = ''
      if (docTypeRows.length > 0) {
        let codes = ''
        let labels = ''
        let keys = ''
        for (const item of docTypeRows) {
          if (codes) {
            codes += ','
          }
          codes += item.code
          if (labels) {
            labels += ','
          }
          labels += (this.isZh ? item.chineseName : item.englishName)
          if (keys) {
            keys += ','
          }
          keys += item.uuid
        }
        fileCategory = codes
        fileCategoryLabel = labels
        documentTypeUuid = keys
      } else {
        fileCategory = ''
        fileCategoryLabel = ''
        documentTypeUuid = ''
      }
      if (this.docTypeTree.isBatchSave) {
        const rows = this.gridApi.getSelectedRows()
        for (const row of rows) {
          row.fileCategory = fileCategory
          row.fileCategoryLabel = fileCategoryLabel
          row.documentTypeUuid = documentTypeUuid
        }
      } else {
        if (this.selectedFile) {
          this.selectedFile.fileCategory = fileCategory
          this.selectedFile.fileCategoryLabel = fileCategoryLabel
          this.selectedFile.documentTypeUuid = documentTypeUuid
        }
      }
      this.gridApi.refreshCells({ force: true })
      this.docTypeTree.visible = false
    },
    batchSetCategory() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.docTypeTree.rowData.forEach(item => {
        item.checked = false
      })
      this.docTypeTree.rowData = [...this.docTypeTree.rowData]
      this.docTypeTree.isBatchSave = true
      this.docTypeTree.visible = true
    },
    remove() {
      //  const rows = this.gridApi.getSelectedRows()
      if (!this.selectedFile) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      this.$confirm(
        this.$t('common.tips.confirmDelete'),
        this.$t('common.tips.prompt'),
        {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          type: 'warning'
        }
      )
        .then(async() => {
          const row = this.selectedFile
          if (this.isSirui && row.fileId) {
            const requestParams = {}
            requestParams.fileIds = row.fileId
            requestParams.billPaymentUuid = this.otherParam.billPaymentUuid
            requestParams.userId = this.otherParam.inputBy
            deleteFileToWeaver(requestParams).then(res => {
              if (res.data.result) {
                // 删除成功
                this.$message.success(this.$t('Message.DeleteSuccessfully'))
              } else {
                // 删除失败
                this.$message.warning(res.data.message)
              }
            })
          } else if (row.fileId) {
            const success = await deleteFile(row.fileId).then(res => res.data)
            if (success !== 'success') {
              this.$message.warning(this.$t('Message.DeleteFileFailed'))
              return
            }
          }
          this.rowData = this.rowData.filter(p => p.seq !== row.seq)
        })
        .catch(() => {})
    },
    upload() {
      if (this.otherUploadFunc) {
        this.otherUploadFunc(this.uploadFunc)
      } else {
        this.uploadFunc()
      }
    },
    async uploadFunc(billCheck) {
      this.otherProcessing = []
      this.batchUploading = false
      const rows = this.rowData.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      this.loading = getLoading('upload-table')
      this.uploading = true
      this.gridApi.refreshCells({ force: true })
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = JobUtils.initUploadFileParam(p.params)
            if (!params.hasOwnProperty('documentType')) {
              params.documentType = p.fileCategory || 'other'
            }
            params.documentName = p.fileCategoryLabel || 'other'
            params.fileSource = ChargeItemTarget.UPLOAD.code
            if (this.isSirui) {
              params.inputBy = this.otherParam.inputBy
              return uploadBillPaymentStorage(params).then(res => {
                p.fileId = res.data
                p.fileCategory = params.documentType
                p.fileCategoryLabel = params.documentName
              })
            } else if (this.batchUploadData && (this.batchUploadData.isMbl || this.batchUploadData.isJobNo)) {
              this.batchUploading = true
              if (this.batchUploadData.isMbl) {
                params.isMbl = 1
              } else {
                params.isJobNo = 1
              }
              params.branchId = this.$store.getters.currentOfficeId
              if (p.duplicate && p.duplicate === 1) {
                return
              }
              return batchUploadStorage(params).then(res => {
                p.jobUuid = res.data.jobUuid
                p.fileId = res.data.fileId
                p.fileCategory = params.documentType
                p.fileCategoryLabel = params.documentName
                p.jobList = res.data.jobList
                if (res.data.jobNum && Number(res.data.jobNum) > 1) {
                  p.uploadProgress = this.$t('CargoMsg.Cargo_ImportedMultipleBusiness')
                } else {
                  p.uploadProgress = this.$t('Message.UploadSuccessful')
                }
                // 报关单解析
                const types = params.documentType.split(',')
                if (billCheck && this.checkFileType(types)) {
                  this.otherProcessing.push(p)
                }
              }).catch((e) => {
                p.uploadProgress = e
              })
            } else {
              return uploadStorage(params).then(res => {
                p.fileId = res.data
                p.fileCategory = params.documentType
                p.fileCategoryLabel = params.documentName
              })
            }
          })
        )
      } catch {
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          this.$t('queryJob.Upload0UploadFailed0', [uploadSuccessCount, uploadFailCount]),
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      } finally {
        this.$emit('uploadDoneOtherProcessing', { row: this.otherProcessing })
        this.loading.close()
        this.uploading = false
        if (!this.batchUploading) {
          this.innerVisible = false
        }
        this.gridApi.refreshCells({ force: true })
      }
    },
    checkFileType(types) {
      return (types.includes('declarations') || types.includes('customDeclarationNote') || types.includes('CUSTOMDECLARATIONNOTE'))
    }
  }
}
</script>
<style lang="scss">

</style>
<style scoped>
.not-click {
  pointer-events: none;
}
</style>
